{
  "storefront_options_page": {
    "header": {
      "title": "Options",
      "description": "Configure the SparkLayer Core Script options for this store.",
      "footer": "Learn more about Core Script options",
      "save": "Save & publish",
      "secondary_actions": {
        "discard": "Discard changes",
        "reset": "Reset to defaults",
        "delete": "Delete settings"
      }
    },
    "save_error": "Couldn't save your draft. Please try again.",
    "validation_error": "Some checkout fields need fixing before you can publish.",
    "site_settings_save_error": "Couldn't save your store settings. Please try again.",
    "delete_success": "Your storefront options have been deleted.",
    "delete_error": "Couldn't delete your storefront options. Please try again.",
    "publish_status": {
      "title": "Publishing",
      "badge": {
        "never_published": "Not published",
        "unpublished_changes": "Unpublished changes",
        "up_to_date": "Published"
      },
      "never_published": "Nothing has been published for this environment yet.",
      "unpublished_changes": "Last published {date}. Your changes are not live until you publish.",
      "up_to_date": "Last published {date}. Everything on this page is live."
    },
    "publish_modal": {
      "title": "Save & publish options?",
      "body_live": "These changes will be saved and go live immediately for every customer on your storefront.",
      "body_test": "These changes will be saved and applied to your test environment only. Customers are not affected.",
      "confirm": "Save & publish"
    },
    "discard_modal": {
      "title": "Discard changes?",
      "body": "This will discard your unsaved edits and restore the options as they were last saved. Your published options are unaffected.",
      "confirm": "Discard changes"
    },
    "reset_modal": {
      "title": "Reset to defaults?",
      "body": "This replaces every option on this page with the SparkLayer defaults. Nothing changes on your storefront until you save and publish.",
      "confirm": "Reset to defaults"
    },
    "delete_modal": {
      "title": "Delete all settings?",
      "body": "This permanently deletes your saved and published options for this environment. Your storefront will fall back to the options set in your theme. This cannot be undone.",
      "confirm": "Delete settings"
    },
    "import_export": {
      "title": "Import & export",
      "subtitle": "Import a window.sparkOptions snippet to load its values, or copy this configuration as one.",
      "import": "Import snippet",
      "copy": "Copy snippet",
      "copy_error": "Couldn't copy to the clipboard.",
      "import_success": "Options imported from snippet.",
      "import_error": "Couldn't find an options object in that snippet.",
      "warnings": {
        "title": "Some values couldn't be imported",
        "subtitle": "These settings were left out because they couldn't be read or aren't ones this page can configure. Everything else was imported."
      },
      "modal": {
        "title": "Import options",
        "description": "Paste your window.sparkOptions snippet to import its values. This will overwrite any existing values.",
        "placeholder": "window.sparkOptions = '{ ... }' or '{ ... }'",
        "cancel": "Cancel",
        "confirm": "Import"
      }
    },
    "cards": {
      "checkout_settings": {
        "title": "Checkout settings",
        "subtitle": "The fields, payment methods, and cart behaviour your customers see at checkout.",
        "sections": {
          "checkout_elements": {
            "title": "Checkout fields",
            "description": "Standard and custom checkout fields."
          },
          "payment_methods_order": {
            "title": "Payment methods order",
            "description": "Drag to set the order in which payment methods appear at checkout."
          },
          "cart_and_addresses": {
            "title": "Cart & addresses"
          }
        },
        "fields": {
          "save_to_address_book": {
            "label": "Save address to address book by default",
            "description": "Save the customer's address to their address book by default."
          },
          "cart_search_type": {
            "label": "Cart search type",
            "description": "Customise how you want search to work within the SparkLayer Cart.",
            "options": {
              "basic": "SKU/barcode lookup",
              "full": "Search",
              "off": "Hide search"
            }
          },
          "hide_ai_cart_features": {
            "label": "Hide AI features from cart",
            "description": "Hides the AI Intelligent Cart features from the SparkLayer Cart view."
          }
        }
      },
      "my_account_settings": {
        "title": "My Account settings",
        "subtitle": "What customers can see and do in their account area.",
        "sections": {
          "account_sections": {
            "title": "Account sections",
            "description": "Drag to set the display order. Toggle visibility to add or remove section IDs from the hidden list."
          }
        },
        "fields": {
          "hide_financials": {
            "label": "Hide financial figures",
            "description": "Hide financial figures from customers. While enabled, the Financials section of My Account is hidden too."
          },
          "order_list_shipping_address": {
            "label": "Show shipping address in order list",
            "description": "Show each order's shipping address alongside it in the order list."
          },
          "payment_visibility": {
            "label": "Enable payments visibility",
            "description": "Show the payment status of orders in the My Account area."
          },
          "purchase_timeline": {
            "label": "Enable timeline & communications",
            "description": "Allow customers and sales agents to send messages and updates on quotes and orders."
          },
          "show_favourites_lists": {
            "label": "Show favourites lists",
            "description": "Let customers save products to a favourites list across the storefront."
          },
          "show_shopping_lists": {
            "label": "Show shopping lists",
            "description": "Let customers save products to reusable shopping lists across the storefront."
          }
        },
        "financials_hidden_by_hide_financials": "Hidden automatically while \"Hide financial figures\" is enabled.",
        "my_account_slot_hidden_by_show_slots": "Hidden automatically until the spark-slot-my-account slot is enabled.",
        "favourites_hidden_by_show_favourites_lists": "Hidden automatically while \"Show favourites lists\" is disabled.",
        "shopping_lists_hidden_by_show_shopping_lists": "Hidden automatically while \"Show shopping lists\" is disabled."
      },
      "translation_overrides": {
        "title": "Translation overrides",
        "subtitle": "Override SparkLayer's built-in text, per language.",
        "fields": {
          "show_translations": {
            "label": "Show translation keys",
            "description": "Debug mode - shows translation keys instead of translated text."
          }
        }
      },
      "pricing_settings": {
        "title": "Pricing & display",
        "subtitle": "How prices, savings, and SparkLayer's product widgets appear on your storefront.",
        "fields": {
          "savings_use_rrp": {
            "label": "Base savings on RRP",
            "description": "Calculate displayed savings against the RRP rather than the customer's own price."
          },
          "show_rrp_toggle": {
            "label": "Show the RRP toggle",
            "description": "Let customers switch between seeing the RRP and their own prices."
          },
          "show_price_break_savings": {
            "label": "Show savings on price breaks",
            "description": "Show the amount saved next to each quantity price break."
          },
          "round_price_break_percentages": {
            "label": "Round price break percentages",
            "description": "Round price break discount percentages to whole numbers."
          },
          "apply_price_breaks_across_variants": {
            "label": "Apply tiered pricing across variants",
            "description": "If products have variants, tiered pricing will be applied across all available variants."
          },
          "dark_theme": {
            "label": "Enable dark theme",
            "description": "Render SparkLayer's components using the dark colour scheme."
          }
        }
      },
      "slots": {
        "title": "Custom slots",
        "subtitle": "The list of custom slots to display."
      },
      "analytics": {
        "title": "Analytics",
        "subtitle": "Configure analytics providers and the events they should listen to."
      }
    }
  }
}
